import { IPercentOfTotalReportColumn, IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';
import { Draft } from 'immer';
import { RCVizQuery } from './utils';

export function setVisualizationQueryCategorizedByColumn(
  draft: Draft<RCVizQuery>,
  categorizedByColumn: IReportColumn
): void {
  draft.categorizedByColumn = categorizedByColumn;
  if (draft.showColumnAsPercentOfTotal) {
    (draft.showColumn as IPercentOfTotalReportColumn).excludedCategorizedByValues = [];
  }
}
